import { connect } from 'react-redux';

import { selectors } from 'dux/catalog';
import { selectors as createSelectors } from 'dux/createInstance';
import { selectors as orgSelectors } from 'dux/org';
import StepOne from './StepOne';

function mapStateToProps(state) {
  return {
    catalogServiceNames: selectors.getCatalogServicesNames(state),
    selectedService: createSelectors.selectedServiceSelector(state),
    selectedProvider: createSelectors.selectedCloudProviderSelector(state),
    availableServiceSubtypesNames: createSelectors.availableServiceSubtypesNamesSelector(state),
    orgIsAwsOnly: orgSelectors.awsOnlySelector(state),
    isPrivateRegion: createSelectors.isPrivateRegionSelector(state),
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
